<template>
	<div id="footer">
		<div class="container">
			<h1>智见服务</h1>
			<p><span>数据交付</span><span>视频内容分析</span><span>数据治理</span><span>数据采集</span><span>数据安全</span><span>数据防泄漏</span></p>
			<h1 style="margin-top: 40px;">联系我们</h1>
			<p><span>邮箱：info@goldenstand.cn</span><span>电话：400-161-1016</span><span>周一~周五09:00 - 18:00</span></p>
			<p style="padding-bottom:20px">地址：湖北省武汉市武昌区中北路227号东信资本大厦</p>

		</div>
		<p style="font-size:12px;border-top:1px solid #ddd;margin:0;padding:5px 0;">Copyright©2021  武汉深能智见科技股份有限公司 <a href="https://beian.miit.gov.cn/#/Integrated/index" style="color:#fff;">鄂ICP备2020022244号</a></p>
	</div>
</template>

<script>
export default {
  data() {
    return {
      contact:[{
        title:'地址',
        dec:'湖北省武汉市武昌区中北路227号东信资本大厦2310号'
      },{
        title:'邮箱',
        dec:'123@goldenstand.cn'
      },{
        title:'电话',
        dec:'13652458665'
      },{
        title:'工作',
        dec:'周一~周五 09:00 - 18:00'
      }]
    }
  }
}
</script>

<style lang="scss">
#footer{
	background-color: $--bg-primary;
 	color:rgb(204, 218, 225);
 	padding:0;
	text-align: center; 
	h1{
		color: #fff;
		font-weight: bold;
		margin:40px 0;
		font-size:16px;
		margin-bottom: 20px;
	}
	p{
		font-size: 14px;
		color: #fff!important;
		span{
			padding:0 30px;
			border-right: 1px solid;
			color: #fff!important;
			&:last-child{
				border:none;
			}
		}
	}
}
</style>